import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const cities = ["Lee's Summit", "Blue Springs", "Independence", "Raymore", "Belton", "Grain Valley", "Kansas City"];

export default function ServiceArea() {
  return (
    <section id="service-area" className="relative py-24 lg:py-32 border-t border-[#D4AF37]/10" data-testid="service-area-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-8"
          data-testid="service-area-overline"
        >
          Service Area
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#F5F5F5]"
          data-testid="service-area-headline"
        >
          Serving Lee's Summit
          <br />
          <span className="italic text-[#D4AF37]">and the Greater Kansas City Area.</span>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-14 flex flex-wrap items-center justify-center gap-4"
          data-testid="service-area-cities"
        >
          {cities.map((c) => (
            <span
              key={c}
              className="inline-flex items-center gap-2.5 border border-[#D4AF37]/25 text-[#F5F5F5] px-6 py-3.5 text-[11px] tracking-[0.25em] uppercase hover:border-[#D4AF37]/60 transition-colors duration-300"
              data-testid={`service-area-city-${c.toLowerCase().replace(/['\s]+/g, "-")}`}
            >
              <MapPin size={13} strokeWidth={1.5} className="text-[#D4AF37]" />
              {c}
            </span>
          ))}
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="mt-10 text-sm font-light tracking-wide text-[#A3A3A3]"
        >
          And surrounding communities throughout the Kansas City metro.
        </motion.p>
      </div>
    </section>
  );
}
